export default __webpack_public_path__ + "static/media/kids.e0fde843.png";